import type { RankedTrendingQueries } from '@lib/coveo/trendingRanking';
import { failingFetcher } from '@lib/http/fetch';
import useSWR from 'swr';

const NONE: string[] = [];
const RETRY_AFTER_MS = 5 * 60 * 1000;
const MAX_RETRIES = 2;

/**
 * The UA arm's popular and rising queries from /api/coveo/trending. Nothing is
 * requested unless `enabled`; a failure or an empty answer leaves both lists
 * empty, which is the box without trending. The header outlives client
 * navigations, so a failure is retried a couple of times, but only after the
 * route's own few-minute hold on failures could have lapsed.
 */
export const useTrendingSearches = (
  enabled: boolean,
  locale: string
): RankedTrendingQueries => {
  const { data } = useSWR<Partial<RankedTrendingQueries>>(
    enabled ? `/api/coveo/trending?locale=${encodeURIComponent(locale)}` : null,
    failingFetcher,
    {
      revalidateOnFocus: false,
      errorRetryInterval: RETRY_AFTER_MS,
      errorRetryCount: MAX_RETRIES,
    }
  );

  return { top: data?.top ?? NONE, trending: data?.trending ?? NONE };
};
